import { render } from "./xy28.vue?vue&type=template&id=5901c52a&scoped=true"
import script from "./xy28.vue?vue&type=script&lang=js"
export * from "./xy28.vue?vue&type=script&lang=js"

import "./xy28.vue?vue&type=style&index=0&id=5901c52a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5901c52a"]])

export default __exports__